import pathOr from 'ramda/src/pathOr';
import partial from 'ramda/src/partial';

/**
 * @param {string[]} path,
 * @param {any} [default='']
 * @return {any}
 */

const ingestGlobalProp = (...path) => pathOr('', ['dazn', ...path], window);

const ingestServiceDictionaryProp = partial(ingestGlobalProp, ['startupData', 'ServiceDictionary']);

const isPersonalisationEnabled = () => {
    let hasOptedOut = ingestGlobalProp('userProfile', 'Preferences', 'OptedOutFromPersonalisation');

    if (typeof hasOptedOut === 'string') {
        hasOptedOut = hasOptedOut === 'true';
    } else {
        hasOptedOut = Boolean(hasOptedOut);
    }

    return !hasOptedOut;
};

const isCaptionsEnabled = () => {
    const enableClosedCaptions = ingestGlobalProp('dazn', 'startupData', 'FeatureToggles', 'ClosedCaptionsV1');

    return enableClosedCaptions === '' ? false : enableClosedCaptions;
};

const ingestGlobalConfigFromEnvironment = () => ({
    serviceUrls: {
        playback: ingestServiceDictionaryProp('Playback', 'Versions', 'v2', 'ServicePath'),
        resumePoints: ingestServiceDictionaryProp('ResumePoint', 'Versions', 'v1', 'ServicePath'),
        precision: ingestServiceDictionaryProp('PlaybackPrecision', 'Versions', 'v1', 'ServicePath'),
        userActions: ingestServiceDictionaryProp('UserActions', 'Versions', 'v1', 'ServicePath'),
        userActionsWatched: `${ingestServiceDictionaryProp('UserActions', 'Versions', 'v1', 'ServicePath')}/watched`,
    },
    environment: {
        manufacturer: ingestGlobalProp('manufacturer'),
        platform: ingestGlobalProp('platform'),
        viewerId: ingestGlobalProp('userProfile', 'ViewerId'),
        language: ingestGlobalProp('userProfile', 'UserLanguageLocaleKey'),
        personalisationEnabled: isPersonalisationEnabled(),
    },
    analytics: {
        convivaCustomerKey: ingestGlobalProp('startupData', 'Conviva', 'CustomerKey'),
    },
    text: {
        liveLabel: ingestGlobalProp('resourceStringsData', 'Strings', 'player_live'),
    },
    captions: {
        enable: isCaptionsEnabled(),
    },
});

export {
    ingestGlobalConfigFromEnvironment as default,
    ingestGlobalProp,
    ingestServiceDictionaryProp,
    isPersonalisationEnabled,
};
